import React, { useState, useEffect } from 'react'
import { all_routes } from '../../router/all_routes'
import { Link } from 'react-router-dom'
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';
import AddDesignation from './addDesignation';
import ModifyDesignation from './modifyDesignation';
import { API } from '../../../common/Constants';
import useFetch from '../../../hooks/useFetch';
import { getAPIHeaders } from '../../../common/Utils';
import PreLoader from '../../../core/common/preLoader';
import CopyRightInfo from '../../../core/common/copyRightInfo';
import { useAccess } from '../../../hooks/accessContext';
import DeleteModal from '../../../core/modals/deleteModal';
import CustomToast from '../../../core/common/customToast';

const Designation = () => {
  const { hasOrgMgntCreate, hasOrgMgntEdit, hasOrgMgntDelete } = useAccess();
  const { isLoading, data, callFetch } = useFetch();
  const [designations, setDesignations] = useState<any>([]);
  const [editDeptId, setEditDeptId] = useState<number>(0);
  const [viewType, setViewType] = useState<'table' | 'card'>('table');
  const [deleteItem, setDeleteItem] = useState<any>({
    id: undefined,
    message: undefined,
  });
  const [toastSettings, setToastSettings] = useState<{
    show: boolean;
    message: string;
    heading: string;
    type: "ERROR" | "SUCCESS" | "INFO";
  }>({
    show: false,
    message: "Something went wrong please try again later",
    heading: "Oops! Something went wrong",
    type: "ERROR",
  });

  useEffect(() => {
    fetchDesignations();
  }, []);

  useEffect(() => {
    if (data) {
      setDesignations(data);
    }
  }, [data]);

  const fetchDesignations = () => {
    callFetch(
      API.DESIGNATION,
      'GET',
      getAPIHeaders(),
      null,
      null
    );
  };

  const deleteData = (id: number) => {
    callFetch(
      `${API.DESIGNATION}/${id}`,
      'DELETE',
      getAPIHeaders(),
      null,
      null
    )
      .then(() => {
        fetchDesignations();
      })
      .catch(() => {
        setToastSettings((prev) => ({
          ...prev,
          show: true,
        }));
      });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: String, record: any) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>

      ),
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Designation",
      dataIndex: "name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <div className="ms-2 designation-title">
            <p className="text-dark mb-0">
              <h6 className="fw-medium">
                <Link 
                  to="#" 
                  className="text-reset text-decoration-none"
                  onClick={() => { setEditDeptId(record?.id) }}
                  data-bs-toggle="modal"
                  data-bs-target="#edit_designation"
                >
                  {record.name}
                </Link>
              </h6>
            </p>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.name?.localeCompare(b.name),
      defaultSortOrder: 'ascend',
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text: String, record: any) => (
        <span className='description-content'>{text}</span>
      ),
      sorter: (a: any, b: any) => a.description?.localeCompare(b.description),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            hidden={!hasOrgMgntEdit()}
            to="#"
            className="me-2 icon-edit"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#edit_designation"
            onClick={() => {
              setEditDeptId(record?.id);
            }}
            title="Edit Designation"
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            hidden={!hasOrgMgntDelete()}
            to="#"
            className="icon-delete"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
            onClick={() =>
              setDeleteItem({
                id: record.id,
                message: `Are you sure you want to delete ${record.name}? This can't be undone.`,
              })
            }
            title="Delete Designation"
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const renderAddDesignation = () => {
    return <AddDesignation onSuccess={fetchDesignations} />;
  };

  const renderEditDesignation = () => {
    return (
      <ModifyDesignation
        onSuccess={fetchDesignations}
        designation={designations?.find((el: any) => el.id === editDeptId)}
      />
    );
  };

  return (
    <>
      <PreLoader showLoader={isLoading} />
      <DeleteModal
        heading="Confirm Delete"
        message={deleteItem.message}
        onDelete={() => deleteData(deleteItem?.id)}
      />
      <CustomToast
        show={toastSettings?.show}
        message={toastSettings?.message}
        heading={toastSettings?.heading}
        type={toastSettings?.type}
        onClose={() => {
          setToastSettings((prev) => ({
            ...prev,
            show: false,
          }));
        }}
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Designations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Designations
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <button
                  disabled={!hasOrgMgntCreate()}
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_designation"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Designation
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Designation List</h5>
              <div className="view-toggle">
                <button 
                  className={`btn btn-sm me-2 ${viewType === 'table' ? 'btn-primary' : 'btn-outline-primary'}`} 
                  onClick={() => setViewType('table')}
                  aria-label="Switch to table view"
                >
                  <i className="ti ti-table me-1"></i> Table View
                </button>
                <button 
                  className={`btn btn-sm ${viewType === 'card' ? 'btn-primary' : 'btn-outline-primary'}`} 
                  onClick={() => setViewType('card')}
                  aria-label="Switch to card view"
                >
                  <i className="ti ti-layout-grid me-1"></i> Card View
                </button>
              </div>
            </div>
            <div className="card-body p-0">
              {viewType === 'table' ? (
                <Table
                  dataSource={designations}
                  columns={columns}
                  Selection={false}
                  refresh={fetchDesignations}
                />
              ) : (
                <div className="designation-cards p-3">
                  <div className="row">
                    {designations.map((designation: any) => (
                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3" key={designation.id}>
                        <div className="card h-100 border shadow-sm">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm me-3 flex-shrink-0 bg-light-primary rounded-circle">
                                  <span className="text-primary fw-bold">
                                    {designation.name.charAt(0).toUpperCase()}
                                  </span>
                                </div>
                                <h6 className="mb-0 fw-semibold designation-title">
                                  {designation.name}
                                </h6>
                              </div>
                              <span className="badge badge-soft-primary">ID: {designation.id}</span>
                            </div>
                            
                            <div className="designation-description mb-4">
                              <p className="fs-12 text-muted mb-0">
                                {designation.description}
                              </p>
                            </div>
                            
                            <div className="d-flex justify-content-end mt-3">
                              <Link
                                hidden={!hasOrgMgntEdit()}
                                to="#"
                                className="btn btn-sm btn-outline-primary me-2"
                                data-bs-toggle="modal" data-inert={true}
                                data-bs-target="#edit_designation"
                                onClick={() => { setEditDeptId(designation.id) }}
                                title="Edit Designation"
                              >
                                <i className="ti ti-edit me-1" /> Edit
                              </Link>
                              <Link
                                hidden={!hasOrgMgntDelete()}
                                to="#"
                                className="btn btn-sm btn-outline-danger"
                                data-bs-toggle="modal" data-inert={true}
                                data-bs-target="#delete_modal"
                                onClick={() => setDeleteItem({
                                  id: designation.id,
                                  message: `Are you sure you want to delete ${designation.name}? This can't be undone.`,
                                })}
                                title="Delete Designation"
                              >
                                <i className="ti ti-trash me-1" /> Delete
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo />
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Designation */}
      <div className="modal fade" id="add_designation">
        {renderAddDesignation()}
      </div>
      {/* /Add Designation */}
      {/* Edit Designation */}
      <div className="modal fade" id="edit_designation">
        {renderEditDesignation()}
      </div>
      {/* /Edit Designation */}
    </>
  );
};

export default Designation;